import { SESSION_STATUS_DISPLAY_ORDER } from '@/components/ui/session-status/session-status-order';
import { useIsForActionSessionStatusEnabled } from '@/features/flags';
import { SessionStatus } from '@heidi/schema/ml-scribe';
import { useMemo } from 'react';

/**
 * Ordered session statuses a user may currently see as selectable / filterable.
 * `FOR_ACTION` is hidden until `release-scribe-enable-for-action-status`
 * (PostHog) is on — see {@link useIsForActionSessionStatusEnabled}.
 *
 * This gates *selection and filtering only*. Rendering an already-set status
 * stays ungated (resolved via `sessionStatusChipConfig` / `enumToDescription`),
 * so a session set to "For action" still displays correctly when the flag is
 * off.
 */
export const useVisibleSessionStatuses = (): SessionStatus[] => {
  const isForActionEnabled = useIsForActionSessionStatusEnabled();
  // Memoised on the flag value so the reference is stable across renders —
  // consumers feed this into `useMemo`/effect deps (data-table columns,
  // chip-row options, the status-filter sort effect).
  return useMemo(
    () =>
      SESSION_STATUS_DISPLAY_ORDER.filter(
        (status) => status !== SessionStatus.FOR_ACTION || isForActionEnabled
      ),
    [isForActionEnabled]
  );
};
